import { useMemo } from "react";
import { titleCase } from "title-case";

/** Either shape the card policy arrives in: the form's, or the server's. */
interface CategorySource {
  allowedCategories?: { id?: string; name?: string | null }[] | null;
  allowed_categories?: { id?: string; name?: string | null }[] | null;
}

/** The merchant category names on a card policy. See useListMerchant. */
const useListMerchantCategories = (
  cardPolicy?: CategorySource | null,
  /** Kept for the call sites; the hook renders no strings of its own. */
  _t?: unknown,
): string[] =>
  useMemo(() => {
    const categories =
      cardPolicy?.allowedCategories ?? cardPolicy?.allowed_categories;
    if (!categories) return [];
    return categories
      .map((item) => item?.name)
      .filter((name): name is string => Boolean(name))
      .map((name) => titleCase(name.toLowerCase()));
  }, [cardPolicy?.allowedCategories, cardPolicy?.allowed_categories]);

export default useListMerchantCategories;
